export default "__VITE_ASSET__DxT5E_ZV__"